export default "__VITE_ASSET__f0970e33__"